<template>
  <div class="content">
    <div class="col-md-8 ml-auto mr-auto">
      <h2 class="text-center">{{ $t('posTransactionsPage.title') }}</h2>
      <p class="text-center">
        {{ $t('posTransactionsPage.description') }}
      </p>
    </div>
    <div class="row mt-5">
      <div class="col-12">
        <pos-transactions-filter-form :filter-details="filterDetails"/>
      </div>
      <div class="col-12" v-loading="loading"/>
    </div>

    <div v-if="loading === false && error" class="row mt-3">
      <div class="col-12">
        <base-alert type="danger">
          <strong>{{ $t(`generic.errorTitle`) }}</strong> {{ error }}
        </base-alert>
      </div>
    </div>

    <div class="row mt-2" v-if="!loading && filterDetails && !error">
      <div class="col-12">
        <pos-transactions-table :details="posTransactionsData" :pagination-details="pagination"
                                :filter-details="filterDetails"/>
      </div>
    </div>
  </div>
</template>
<script>
import PosTransactionsTable from 'src/components/PosTransaction/PosTransactionsTable'
import PosTransactionsFilterForm from './PosTransactionsFilterForm'
import {mapState} from "vuex";
import {BaseAlert} from 'src/components';

export default {
  name: 'posTransactionsPage',
  components: {
    PosTransactionsFilterForm,
    PosTransactionsTable,
    BaseAlert
  },
  methods: {},
  computed: {
    ...mapState({
      loading: state => state.pos_transactions.loading,
      posTransactionsData: state => state.pos_transactions.data,
      pagination: state => state.pos_transactions.pagination,
      filterDetails: state => state.pos_transactions.filterDetails,
      error: state => state.pos_transactions.error,
    }),
  },
};
</script>
<style>
</style>
